module.exports = __webpack_public_path__ + "img/whathot_bg_dots_green.13502164.png";